<bn-web-ui-card
  class="mb-4"
  [noPadding]="true">
  <div class="row g-0">
    <div class="col-3 border-right border-dark-2 p-4">
      <p class="text-200-regular text-bunny-dark mb-1">Total HTTP requests</p>
      <p class="text-700-regular text-bunny-dark">{{ (totalBreaches() | metricFormat).formatted }}</p>
    </div>
    <div class="col-3 border-right border-dark-2 p-4">
      <p class="text-200-regular text-bunny-dark mb-1">Total mitigated requests</p>
      <p class="text-700-regular text-bunny-dark">{{ (challengedBreaches() | metricFormat).formatted }}</p>
    </div>
    <div class="col-3 border-right border-dark-2 p-4">
      <p class="text-200-regular text-bunny-dark mb-1">Total logged requests</p>
      <p class="text-700-regular text-bunny-dark">{{ (loggedBreaches() | metricFormat).formatted }}</p>
    </div>
    <div class="col-3 p-4">
      <p class="text-200-regular text-bunny-dark mb-1">Total blocked requests</p>
      <p class="text-700-regular text-bunny-dark">{{ (blockedBreaches() | metricFormat).formatted }}</p>
    </div>
  </div>
</bn-web-ui-card>

@if (rateLimitReached && nextPlan) {
  <bn-web-ui-alert
    alertType="danger"
    class="my-4"
    heading="You have reached the maximum number of allowed rate limit rules."
    [showIcon]="true">
    @if (nextPlan === planType.Advanced) {
      <span>Upgrade to Advanced plan or contact Support to increase your limit.</span>
    }
    @if (nextPlan === planType.Business) {
      <span>Upgrade to Business plan or contact Support to increase your limit.</span>
    }
    @if (nextPlan === planType.Enterprise) {
      <span>Upgrade to Enterprise plan or contact Support to increase your limit.</span>
    }
  </bn-web-ui-alert>
}

@if (tableData?.length) {
  <div class="my-4">{{ rateLimitsPagination()?.totalCount }}/{{ getSelectedShield()?.rateLimitRulesLimit }} rules used</div>
}
<ng-container>
  <bn-web-ui-table
    class="d-block mb-4"
    [columns]="tableColumns"
    [isLoading]="isDeleting()"
    [noDataOptions]="{
      size: 'lg',
      title: 'No rate limit rules yet',
      description: 'Set up rate limits to control traffic, prevent abuse, and safeguard your website from potential threats.',
      imageOptions: {
        fileName: 'bunny-debugging.svg',
        bottom: '0px',
        top: '0px',
        isAbsolute: true,
      },
      buttonsOptions: [
        {
          text: 'Create First Rate Limit Rule',
          routerLink: './add',
        },
      ],
    }"
    [paginationOptions]="{
      currentPage: rateLimitsPagination()?.currentPage,
      perPage: rateLimitsPagination()?.pageSize,
      totalItems: rateLimitsPagination()?.totalCount,
      queryParamEnabled: true,
    }"
    [tableDataSource]="tableData"
    (dropdownClick)="onDropdownClick($event)"
    (pageChange)="handlePageChange($event)" />
</ng-container>

<bn-web-ui-documentation
  [linksFirst]="linksFirst"
  [titleFirst]="titleFirst" />
